import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
const initialState = {
  quoteStatusType: [],
  status: false,
  error: null,
};
export const fetchQuoteStatusType = createAsyncThunk(
  'master/fetchQuoteStatusType',
  async (_, { getState, rejectWithValue }) => {
    const { quoteStatusType } = getState().quoteStatusType;
    if (quoteStatusType && quoteStatusType.length > 0) {
      return rejectWithValue('Quote status type already fetched');
    } else {
      const response = await ApiService.get('/system/status?statusType=Quote');
      return response;
    }
  }
);
const quoteStatusTypeSlice = createSlice({
  name: 'quoteStatusType',
  initialState,
  reducers: {
    clearQuoteStatusType: state => {
      state.quoteStatusType = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchQuoteStatusType.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchQuoteStatusType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.quoteStatusType = action?.payload || [];
      })
      .addCase(fetchQuoteStatusType.rejected, (state, action) => {
        if (action.payload === 'Quote status type already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.error.message;
        }
      });
  },
});
export const { clearQuoteStatusType } = quoteStatusTypeSlice.actions;

export const quoteStatusTypeReducer = quoteStatusTypeSlice.reducer;
